$(document).ready(function () {

	$(".text-content").each(function(){
		var text_content = $(this);
		text_content.find("table").each(function(){
			var table = $(this);
			var table_wrap = $("<div class='table-wrap'>");
			
			table_wrap.insertBefore(table);
			table_wrap.append(table);
			
			
		})
		
	})
});